import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useQuasar } from 'quasar'
import { useStore } from 'vuex'
import { DisplayStatus, Status } from '@/models/status'

import Directr from '@/services/directr'
import { CtDraft, CtEvent, CtOrder } from '@/models/interfaces/content-type'

import DraftProductList from '../../components/DraftProductList.vue'
import AddressEditor from '@/components/AddressEditor.vue'
import ProductSearch from './ProductSearchModal.vue'
import DButton from '@/components/base/DButton.vue'
import OrderEventTimeline from '../../components/OrderEventTimeline.vue'
import OrderErrorDetails from '../../components/OrderErrorDetails.vue'
import OrderFulfillmentDetails from '../../components/OrderFulfillmentDetails.vue'
import ExternalLinkIcon from '@/components/Icons/ExternalLinkIcon.vue'
import { errorToReadableString } from '@/utils/error'


export default /*@__PURE__*/_defineComponent({
  __name: 'IssueEditor',
  props: {
    modelValue: {},
    link: {}
  },
  emits: ['update:model-value', 'close', 'noteAdded', 'reset', 'resolve', 'updated'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const $q = useQuasar()
const $store = useStore()
const $directr: Directr = $store.getters['Services/Directr']
const isMobile = computed(() => $q.screen.lt.md)

const props = __props

const emit = __emit

const showSearch = ref(false)
const target = ref<number>(-1)
const events = ref<Array<CtEvent>>([])

const note = ref('')
const addingNote = ref(false)
const fulfillmentData = ref({ fulfillment: props.modelValue?.fulfillments, labels: props.modelValue?.shipments })

const statusOptions = { 'Ready to Pick': Status.Queued, 'Picked': Status.Started, 'On-Hold': Status.Paused }

const errorMessage = computed(() => {
  if (!props.modelValue.status_info?.failed) return 'No error was specified'
  return errorToReadableString(props.modelValue.status_info?.failed)
})

// onMounted(() => fetchEvents())
watch(() => props.modelValue, value => {
  fulfillmentData.value.fulfillment = props.modelValue?.fulfillments
  fulfillmentData.value.labels = props.modelValue?.shipments
  note.value = ''
  addingNote.value = false
})
// async function fetchEvents () {
//   const items = await $directr.get('event', [{ field: 'reference', method: 'is', match: props.modelValue?.sys.id }])
//     .then((res) => res.items)

//   events.value = items || []
// }

function searchProducts (index: number) {
  showSearch.value = true
  target.value = index
}

function openMirrorUrl (link) {
  window.open(link, '_blank')?.focus()
}

function commitSearch (selection) {
  const updated = props.modelValue

  if (!updated.raw) return console.warn('Tried to update draft products, but the draft had no "raw" field')
  if (target.value === undefined || target.value < 0) return console.warn('Tried to update draft products, but the set target product index was invalid')

  updated.raw.products[target.value] = { ...selection[0], quantity: updated.raw.products[target.value].quantity || 1 }

  target.value = -1
  emit('update:model-value', updated)
}

function addNote () {
  addingNote.value = true
}

function updateNote () {
  addingNote.value = false
  emit('noteAdded', props.modelValue.sys.id, note.value)
  note.value = ''
  // reload events
}

function resetOrder () {
  emit('reset', props.modelValue.sys.id)
  // reload events
}

function resolveIssue (status?: Status) {
  emit('resolve', props.modelValue.sys.id, status)
}


const __returned__ = { $q, $store, $directr, isMobile, props, emit, showSearch, target, events, note, addingNote, fulfillmentData, statusOptions, errorMessage, searchProducts, openMirrorUrl, commitSearch, addNote, updateNote, resetOrder, resolveIssue, computed, onMounted, ref, watch, get useQuasar() { return useQuasar }, get useStore() { return useStore }, get DisplayStatus() { return DisplayStatus }, get Status() { return Status }, get Directr() { return Directr }, get CtDraft() { return CtDraft }, get CtEvent() { return CtEvent }, get CtOrder() { return CtOrder }, DraftProductList, AddressEditor, ProductSearch, DButton, OrderEventTimeline, OrderErrorDetails, OrderFulfillmentDetails, ExternalLinkIcon, get errorToReadableString() { return errorToReadableString } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})